<!-- 
	OptinOutForm
	props: User
    role: User
    DEPRECIATED
	Called by @/views/OptOut to allow user to remove themself from the lottery
    Calls API and requires Admin action to process this action
-->

<template>
<div class="DialogInsightFormDiv" id="divForm_DIForm_709_26036" style="display:none;background-color:white;padding: 50px;">
	<a name="divForm_DIForm_709_26036_globalErrors_anchor"></a>
	<div class="DialogInsightGlobalErrors" id="divForm_DIForm_709_26036_globalErrors"></div>
	<div class="DialogInsightFormContainer royal" style="font-weight: bold;">

      
      <div>
         <p class="text-24 gold-1">Your Identification</p>
      </div>
      
		<div class="DialogInsightFormRow">
			<div class="DialogInsightLabel_AboveField">Employee ID:</div>
         {{ form.employeeId }} 
			<div class="DialogInsightInputContainer" style="display:none;">
				<input type="text" class="DialogInsightFormInput" id="DIField_26036_f_EmployeeID" maxlength="8" v-model="form.employeeId" readonly />
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_EmployeeID_errors"></div>
			</div>
		</div>
		<div class="DialogInsightFormRow">
			<div class="DialogInsightLabel_AboveField">Email:</div>
         {{ form.email }}
			<div class="DialogInsightInputContainer" style="display:none;">
				<input type="text" class="DialogInsightFormInput" id="DIField_26036_f_EMail" maxlength="125" v-model="form.email" readonly />
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_EMail_errors"></div>
			</div>
		</div>
		<div class="DialogInsightFormRow">
			<div class="DialogInsightLabel_AboveField">First Name:</div>
         {{ form.firstName }}
			<div class="DialogInsightInputContainer" style="display:none;">
				<input type="text" class="DialogInsightFormInput" id="DIField_26036_f_FirstName" maxlength="50" v-model="form.firstName" readonly />
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_FirstName_errors"></div>
			</div>
		</div>
		<div class="DialogInsightFormRow">
			<div class="DialogInsightLabel_AboveField">Last Name:</div>
         {{ form.lastName }}
			<div class="DialogInsightInputContainer" style="display:none;">
				<input type="text" class="DialogInsightFormInput" id="DIField_26036_f_LastName" maxlength="50" v-model="form.lastName" readonly />
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_LastName_errors"></div>
			</div>
		</div>
		<div>
         <p class="text-24 gold-1">Your Participation</p>
      </div>
		<div class="DialogInsightFormRow">
			<div class="DialogInsightLabel_AboveField">Reason For Opt-out:</div>
			<div class="DialogInsightInputContainer">
				<select class="DialogInsightFormInput" id="DIField_26036_f_ReasonForOptout">
					<option value="Reduced work hours" style="color: #000000;">Reduced work hours/Change in job status (ex. Full time to Casual)</option>
					<option value="Leave of Absence" style="color: #000000;">Leave of Absence (includes Maternity/Paternity)</option>
					<option value="No longer interested" style="color: #000000;">No longer interested in participation</option>
					<option value="No longer employed" style="color: #000000;">No longer employed</option>
					<option value="Other" style="color: #000000;">Other</option>
				</select>
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_ReasonForOptout_errors"></div>
			</div>
		</div>
      <div class="DialogInsightFormRow" v-show="formABundle">
			<div class="DialogInsightInputContainer">
				<input type="checkbox" @click="bundleOptOutHandler" />
				<label style="padding-left: 10px;">2026 - Opt Out Bundle</label>
			</div>
		</div>
		<div class="DialogInsightFormRow" v-show="!formABundle">
			<div class="DialogInsightInputContainer">
				<input type="checkbox" class="DialogInsightFormInput" id="DIField_26036_f_OptOutMain" v-model="optOutCheckedMain"/>
				<label for="DIField_26036_f_OptOutMain" style="padding-left: 10px;">Opt Out WinWin Staff Lottery</label>
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_OptOutMain_errors"></div>
			</div>
		</div>
		<div class="DialogInsightFormRow" v-show="!formABundle">
			<div class="DialogInsightInputContainer">
				<input type="checkbox" class="DialogInsightFormInput" id="DIField_26036_f_OptOut5050" v-model="optOutChecked50"/>
				<label for="DIField_26036_f_OptOut5050" style="padding-left: 10px;">Opt Out Quarterly Cash 5050</label>
				<div class="DialogInsightErrorContainer" id="DIField_26036_f_OptOut5050_errors"></div>
			</div>
		</div>
		<div class="DialogInsightFormSubmit">
         <button class="button2 royal" type="button" @click.prevent="validateAndSubmit">Submit</button>
			<img class="DialogInsightFormSubmitLoader" src="https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif" />
		</div>
	</div>

	<div class="DialogInsightFormSuccessDiv" id="divForm_DIForm_709_26036_success" style="padding:10px; display: none;">
      <div class="container clearfix">
         <div class="emphasis-title nobottommargin">
         <span
            class="poppins opt-out-confirmation-title text-5xl font-extrabold tracking-wide lh1-3 m-0 mt-5 center  text-shadow-lg"
         >
            <span class="opt-out-section">OPT-OUT</span>&nbsp;
            <span class="">CONFIRMED</span>
         </span>
         </div>
      </div>
      <br />
      <div
         class="container clearfix p-5 opt-out-confirmation-box"
      >
         <p class="poppins text-left">
         We have received your submission to opt-out of the WinWin Staff Lottery and/or the
         Quarterly Cash 50/50 Payroll Deduction Program. You should receive a confirmation email
         shortly.
         </p>
         <p class="poppins text-left">
         If you do not receive your confirmation email, please check your junk/spam folder or
         contact us at
         <a
            href="mailto:customerservice@winwinstafflottery.ca"
            class="block text-indigo-400"
            target="_blank"
            >customerservice@winwinstafflottery.ca</a
         >
         </p>
      </div>
   </div>
   <Alert v-if="showInvalidFormMessage">
      Please, select at least one package type for submitting the opt-out request
   </Alert>
</div>


<!-- 
<div class="DialogInsightFormDiv" id="divForm_DIForm_709_18560" style="display:none">
            <a name="divForm_DIForm_709_18560_globalErrors_anchor"></a>
            <div class="DialogInsightGlobalErrors" id="divForm_DIForm_709_18560_globalErrors"></div>
            <div class="DialogInsightFormContainer">


                <div class="">

                    <div class="container py-6">

                        <div class="emphasis-title center">
                            <h1 class="eloquent gold-ombre lh1-3 m-0 mt-5" style="text-align:center;font-size:400%;">OPT OUT</h1>
                            <p class="poppins text-36 lead text-white notopmargin" style="text-align:center;">We're sorry to see you go...</p>
                            <br>
                            <p class="poppins text-20 lead notopmargin text-white" style="text-align:center;">...but if you no longer wish to participate in WinWin Staff Lottery payroll deductions,<br>please complete the form below.</p>
                            <br>
                            <p class="poppins small t500 topmargin-sm nobottommargin warning" style="text-align:center;font-size:80%;">Please Note: Removal from the payroll deduction program can take up to 2 weeks.</p>
                        </div>

                        <div class="mx-auto card bg-white" style="max-width: 800px">

                            <div class="row justify-content">

                                <div class="m-0 bg-black-box-flip mx-auto card" style="width:40%;background-color: #1A1F56;">

                                    <div class="t500 initialism center py-2 mt-5 alabaster text-14 lh1-5 white" style="text-align:center">YOUR <u>8-DIGIT</u> EMPLOYEE ID</div>

                                    <div class="mb-0 px-4 mt-1 pb-3">
                                        <div class="DialogInsightFormRow">
                                            <div class="DialogInsightInputContainer">
                                                <div class="DialogInsightInputWithPlaceholderContainer bg-white">
                                                    <span unselectable="on" class="DialogInsightInputPlaceholderText">Your Employee ID</span>
                                                    <input onblur="checkLength(this)" type="text" class="DialogInsightFormInput DialogInsightInputWithPlaceholder" 
                                                      v-model="form.employeeId" readonly id="DIField_18560_f_EmployeeID" onKeyPress="if(this.value.length==8) return false;" />
                                                </div>
                                                <div class="DialogInsightErrorContainer" id="DIField_18560_f_EmployeeID_errors"></div>
                                            </div>
                                        </div>
                                    </div>



                                </div>

                                <div class="p-4 m-0 bg-white" style="width:60%;">

                                    <div class="m-2">
                                        <div class="DialogInsightFormRow">
                                            <div class="DialogInsightInputContainer">
                                                <div class="DialogInsightInputWithPlaceholderContainer bg-white">
                                                    <span unselectable="on" class="DialogInsightInputPlaceholderText">Email</span>
                                                    <input type="text" class="DialogInsightFormInput DialogInsightInputWithPlaceholder" 
                                                      v-model="form.email" readonly id="DIField_18560_f_EMail" maxlength="125" />
                                                </div>
                                                <div class="DialogInsightErrorContainer" id="DIField_18560_f_EMail_errors"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="m-2">
                                        <div class="DialogInsightFormRow">
                                            <div class="DialogInsightInputContainer">
                                                <div class="DialogInsightInputWithPlaceholderContainer bg-white">
                                                    <span unselectable="on" class="DialogInsightInputPlaceholderText">First Name</span>
                                                    <input type="text" class="DialogInsightFormInput DialogInsightInputWithPlaceholder" 
                                                      v-model="form.firstName" readonly id="DIField_18560_f_FirstName" maxlength="50" />
                                                </div>
                                                <div class="DialogInsightErrorContainer" id="DIField_18560_f_FirstName_errors"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="m-2">
                                        <div class="DialogInsightFormRow pb-0">
                                            <div class="DialogInsightInputContainer">
                                                <div class="DialogInsightInputWithPlaceholderContainer bg-white">
                                                    <span unselectable="on" class="DialogInsightInputPlaceholderText">Last Name</span>
                                                    <input type="text" class="DialogInsightFormInput DialogInsightInputWithPlaceholder" 
                                                      v-model="form.lastName" readonly id="DIField_18560_f_LastName" maxlength="50" />
                                                </div>
                                                <div class="DialogInsightErrorContainer" id="DIField_18560_f_LastName_errors"></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <br>
                        <br>

                        <div class="row mx-auto bg-white" style="max-width: 800px">



                            <div class="p-0 mt-3" style="width:40%;">

                                <div class="row justify-content">

                                    <div class="col-md-12 my-3 pb-4 mx-auto card" style="min-height: 254px;">

                                        <div class="DialogInsightFormCategoryTitle poppins text-16 t400 my-4 royal text-center initialism" style="text-transform: uppercase;">Please select primary reason for opting out below</div>

                                        <div class="DialogInsightFormRow mt-5 pt-5 px-5">
                                            <div class="DialogInsightInputContainer">
                                                <select class="DialogInsightFormInput" id="DIField_18560_f_ReasonForOptout" style="font-size:85%;">
                                                    <option value="Reduced work hours" style="color: #000000;">Reduced work hours/Change in job status (ex. Full Time to Casual)</option>
                                                    <option value="Leave of Absence" style="color: #000000;">Leave of Absence (includes Maternity/Paternity)</option>
                                                    <option value="No longer interested" style="color: #000000;">No longer interested in participating</option>
                                                    <option value="No longer employed" style="color: #000000;">No longer employed</option>
                                                    <option value="Other" style="color: #000000;">Other</option>
                                                </select>
                                                <div class="DialogInsightErrorContainer" id="DIField_18560_f_ReasonForOptout_errors"></div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div class="p-0 mt-3" style="width:60%;">

                                <div class="row justify-content">

                                    <div class="col-md-12 my-3 pb-4 mx-auto card">

                                        <div class="DialogInsightFormCategoryTitle poppins text-16 t400 my-4 royal text-center initialism" style="text-transform: uppercase;">Select the Payroll Deduction Program you no longer would wish to participate in.</div>

                                        <div class="DialogInsightFormRow row">

                                            <div class="m-0 py-2 mx-auto" style="width:45%;">
                                                <div class="DialogInsightInputContainer">
                                                    <label for="DIField_18560_f_Year2022OptOut" class="card-alt">
                                                        <input class="DialogInsightFormInput card-alt__input " type="checkbox" id="DIField_18560_f_Year2022OptOut" />
                                                        <div class="card-alt__body">
                                                            <div class="card-alt__body-cover"><img class="card-alt__body-cover-image" src="https://winwinstafflottery.com/images/enrollment/WinWinStaffLottery.svg" /><span class="card-alt__body-cover-checkbox">
                                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                                                                        
                                                                        <path class="st0" d="M24,20.2L15.7,12l8.2-8.3L20.2,0L12,8.3L3.7,0.1L0,3.8L8.3,12l-8.2,8.3L3.8,24l8.2-8.3l8.3,8.2L24,20.2z" />
                                                                    </svg>
                                                                </span>
                                                            </div>



                                                            <header class="card-alt__body-header">
                                                                
                                                                <p class="card-alt__body-header-subtitle">WinWin Staff Lottery Opt-out</p>
                                                            </header>
                                                        </div>
                                                    </label>
                                                    <div class="DialogInsightErrorContainer" id="DIField_18560_f_Year2022OptOut_errors"></div>
                                                </div>
                                            </div>

                                            <div class="m-0 py-2 mx-auto" style="width:45%;">
                                                <div class="DialogInsightInputContainer">
                                                    <label for="DIField_18560_f_Year2022OptOut5050" class="card-alt">
                                                        <input class="DialogInsightFormInput card-alt__input" type="checkbox" id="DIField_18560_f_Year2022OptOut5050" />
                                                        <div class="card-alt__body">
                                                            <div class="card-alt__body-cover"><img class="card-alt__body-cover-image" src="https://winwinstafflottery.com/images/enrollment/QuarterlyCash5050-Dark.svg" /><span class="card-alt__body-cover-checkbox">
                                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                                                                        
                                                                        <path class="st0" d="M24,20.2L15.7,12l8.2-8.3L20.2,0L12,8.3L3.7,0.1L0,3.8L8.3,12l-8.2,8.3L3.8,24l8.2-8.3l8.3,8.2L24,20.2z" />
                                                                    </svg>
                                                                    
                                                                </span>
                                                            </div>
                                                            <header class="card-alt__body-header">
                                                                
                                                                <p class="card-alt__body-header-subtitle">Quarterly Cash 50/50 Opt-out</p>
                                                            </header>
                                                        </div>
                                                    </label>
                                                    <div class="DialogInsightErrorContainer" id="DIField_18560_f_Year2022OptOut5050_errors"></div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>



                        </div>

                        <div class="DialogInsightFormSubmit center pt-4 pb-6" style="margin: auto; width: 30%;">
                            <input type="submit" value="SUBMIT OPT-OUT REQUEST" onclick="DI.Forms.Optin.Client.GetOptinForm('DIForm_709_18560').Submit(this); return false;" class="button tab-action-btn-next float-end royal" />
                            <img class="DialogInsightFormSubmitLoader" src="https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif" />
                        </div>


                    </div>

                </div>

            </div>

            <div class="DialogInsightFormSuccessDiv" id="divForm_DIForm_709_18560_success" style="padding:10px; display: none;">

                <div class="container clearfix">
                    <div class="emphasis-title nobottommargin">
                        <h1 class="eloquent gold-ombre lh1-3 m-0 mt-5 center" style="font-size:400%;">REMEMBER</h1>
                    </div>
                </div>
               <br>
                <div class="container clearfix center">

                    <div class="heading-block center bottommargin-sm">
                        <p class="poppins text-20 lead notopmargin text-white">You can always opt back in: <a href="/settings/update-tickets" class="t600 gold-ombre">GET TICKETS</a>.</p>
                        <span class="poppins text-20 lead notopmargin text-white lh1-5">When you buy a WinWin Staff Lottery ticket, proceeds are invested directly back to Alberta Area Hospitals.<br>That means it supports your hospitals and your community!<br><br>Together we can make a significant difference for our health care facilities across the province.</span>
                    </div>
                     <br>
                     <br>
                    <h1 class="eloquent gold-ombre lh1-3 m-0 my-5" style="font-size:300%;">NOW THAT'S A WIN-WIN!</h1>

                    <a href="/user">
          	         <button
                        class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
          	         >
                        VIEW MY PROFILE
          	         </button>
        	            </a>

                </div>

                <div class="promo parallax promo-dark promo-flat promo-full nomargin contactInformation" style="padding: 40px 0!important;" data-stellar-background-ratio="0.5">
                    <div class="container clearfix center">
                        <h1 class="white" style="font-size:140%;font-weight: bold;">If you have any further questions or concerns, <br> please contact customer service at <br> <span style="color:gold;">1-844-594-6946</span></h1>
                        <span style="color:white;">Customer Service Representatives are Available Weekdays from 8AM-5PM</span>
                    </div>
                </div>
            </div>

        </div>
      -->
  <!--div
    id="divForm_DIForm_709_18560"
    class="DialogInsightFormDiv"
    style="display:none"
  >
    <a name="divForm_DIForm_709_18560_globalErrors_anchor" />
    <div
      id="divForm_DIForm_709_18560_globalErrors"
      class="DialogInsightGlobalErrors"
    />
    <div class="DialogInsightFormContainer">
      <div style="background-color: #ffffff;">
        <div class="container py-6">
          <div class="emphasis-title center">
            <p class="poppins text-64 gold ls2 t300">
              OPT OUT
            </p>
            <p class="poppins text-36 lead notopmargin">
              We're sorry to see you go...
            </p>
            <p class="poppins text-20 lead notopmargin royal">
              ...but if you no longer wish to participate in WinWin Staff Lottery payroll deductions,<br>please complete the form below.
            </p>
            <p class="poppins red small t500 topmargin-sm nobottommargin">
              Please Note: Removal from the payroll deduction program can take up to 2 weeks.
            </p>
          </div>
														
          <div
            class="mx-auto card"
            style="max-width: 800px"
          >
            <div class="row justify-content">
              <div class="col-md-5 m-0 bg-black-box-flip mx-auto card">
                <div class="mb-0 px-4 pt-5 mt-4 pb-3">	
                  <div class="DialogInsightFormRow">
                    <div class="DialogInsightInputContainer">
                      <div class="DialogInsightInputWithPlaceholderContainer bg-white">
                        <span
                          unselectable="on"
                          class="DialogInsightInputPlaceholderText"
                        >Your Employee ID</span>
                        <input
                          id="DIField_18560_f_EmployeeID"
                          onblur="checkLength(this)"
                          type="text"
                          class="DialogInsightFormInput DialogInsightInputWithPlaceholder"
                          maxlength="8"
                          v-model="form.employeeId"
                          style="background-color: rgba(0,0,0,0.1)"
                          readonly
                        >
                      </div>
                      <div
                        id="DIField_18560_f_EmployeeID_errors"
                        class="DialogInsightErrorContainer"
                      />
                    </div>
                  </div>
                </div>

                <div class="t500 initialism center py-2 mt-0 alabaster text-14 lh1-5">
                  Please use only the last <u>8-digits</u> of your Employee ID
                </div>
              </div>

              <div class="col-md-7 p-4 m-0">
                <div class="m-2">
                  <div class="DialogInsightFormRow">
                    <div class="DialogInsightInputContainer">
                      <div class="DialogInsightInputWithPlaceholderContainer">
                        <span
                          unselectable="on"
                          class="DialogInsightInputPlaceholderText"
                        >Email</span>
                        <input
                          id="DIField_18560_f_EMail"
                          type="text"
                          class="DialogInsightFormInput DialogInsightInputWithPlaceholder"
                          maxlength="125"
                          readonly
                          v-model="form.email"
                          style="background-color: rgba(0,0,0,0.1)"

                        >
                      </div>
                      <div
                        id="DIField_18560_f_EMail_errors"
                        class="DialogInsightErrorContainer"
                      />
                    </div>
                  </div>
                </div>

                <div class="m-2">		
                  <div class="DialogInsightFormRow">
                    <div class="DialogInsightInputContainer">
                      <div class="DialogInsightInputWithPlaceholderContainer">
                        <span
                          unselectable="on"
                          class="DialogInsightInputPlaceholderText"
                        >First Name</span>
                        <input
                          id="DIField_18560_f_FirstName"
                          type="text"
                          class="DialogInsightFormInput DialogInsightInputWithPlaceholder"
                          maxlength="50"
                          v-model="form.firstName"
                          style="background-color: rgba(0,0,0,0.1)"

                          readonly
                        >
                      </div>
                      <div
                        id="DIField_18560_f_FirstName_errors"
                        class="DialogInsightErrorContainer"
                      />
                    </div>
                  </div>
                </div>	

                <div class="m-2">		
                  <div class="DialogInsightFormRow pb-0">
                    <div class="DialogInsightInputContainer">
                      <div class="DialogInsightInputWithPlaceholderContainer">
                        <span
                          unselectable="on"
                          class="DialogInsightInputPlaceholderText"
                        >Last Name</span>
                        <input
                          id="DIField_18560_f_LastName"
                          type="text"
                          class="DialogInsightFormInput DialogInsightInputWithPlaceholder"
                          maxlength="50"
                          v-model="form.lastName"
                          readonly
                          style="background-color: rgba(0,0,0,0.1)"
                        >
                      </div>
                      <div
                        id="DIField_18560_f_LastName_errors"
                        class="DialogInsightErrorContainer"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
	
	
														
          <div
            class="mx-auto"
            style="max-width: 800px"
          >
            <div class="row justify-content">
              <div class="col-md-12 my-3 pb-4 mx-auto card">
                <div class="DialogInsightFormCategoryTitle poppins text-16 t400 my-4 royal text-center initialism">
                  Please select primary reason for opting out below
                </div>
			
                <div class="DialogInsightFormRow">
                  <div class="DialogInsightInputContainer">
                    <select
                      id="DIField_18560_f_ReasonForOptout"
                      class="DialogInsightFormInput"
                    >
                      <option
                        value="Reduced work hours"
                        style="color: #000000;"
                      >
                        Reduced work hours/Change in job status (ex. Full Time to Casual)
                      </option>
                      <option
                        value="Leave of Absence"
                        style="color: #000000;"
                      >
                        Leave of Absence (includes Maternity/Paternity)
                      </option>
                      <option
                        value="No longer interested"
                        style="color: #000000;"
                      >
                        No longer interested in participating
                      </option>
                      <option
                        value="No longer employed"
                        style="color: #000000;"
                      >
                        No longer employed
                      </option>
                      <option
                        value="Other"
                        style="color: #000000;"
                      >
                        Other
                      </option>
                    </select>
                    <div
                      id="DIField_18560_f_ReasonForOptout_errors"
                      class="DialogInsightErrorContainer"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
		
          <div class="DialogInsightFormSubmit center pt-4 pb-6">
            <input
              type="submit"
              value="SUBMIT OPT-OUT REQUEST"
              onclick="DI.Forms.Optin.Client.GetOptinForm('DIForm_709_18560').Submit(this); return false;"
              class="button tab-action-btn-next float-end royal"
            >
            <img
              class="DialogInsightFormSubmitLoader"
              src="https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif"
            >
          </div>
        </div>

        <div
          id="divForm_DIForm_709_18560_success"
          class="DialogInsightFormSuccessDiv"
          style="padding:10px; display: none;"
        >
          <div
            class="content-wrap nopadding bg-diagonal"
            style="border-top: 1px solid #bf9b30;"
          >
            <div
              class="section nomargin nobottomborder"
              style="background: url('https://engage.winwin50.ca/WinWin50/2018/images/alberta_proceeds.png'); background-position: center center"
              data-stellar-background-ratio="0.3"
            >
              <div class="container clearfix">
                <div class="emphasis-title nobottommargin">
                  <p class="poppins text-64 royal t300 center">
                    REMEMBER
                  </p>
                </div>
						
                <div class="heading-block center bottommargin-sm">
                  <p class="poppins text-20 gold-link t600 topmargin-sm bottommargin-sm uppercase">
                    You can always opt back in: <a
                      href="https://winwinstafflottery.ca/tickets/"
                      class="t600"
                    >GET TICKETS</a>.
                  </p>
                  <span class=" poppins black text-18 lh1-5">When you buy a WinWin Staff Lottery ticket, proceeds are invested directly back to Alberta Area Hospitals.<br>That means it supports your hospitals and your community!<br><br>Together we can make a significant difference for our health care facilities across the province.</span>
                </div>
						
                <h1 class="poppins text-36 royal t300 center">
                  NOW THAT'S A WIN-WIN!
                </h1>
              </div>
            </div>

            <div
              class="promo parallax promo-dark promo-flat promo-full nomargin"
              style="padding: 40px 0!important;"
              data-stellar-background-ratio="0.5"
            >
              <div class="container clearfix center">
                <h3 class="uppercase">
                  If you have any further questions or concerns, please contact customer service at <span>1-844-594-6946</span>
                </h3>
                <span>Customer Service Representatives are Available Weekdays from 8AM-5PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div-->
</template>
<script>
	import { onMounted } from "@vue/runtime-core";

	import Alert from "@/components/Alert";
	import CustomButton from "@/components/CustomButton";

	export default {
		name: "OptOutForm",
		components: {
         Alert,
			CustomButton,
		},
		props: ["user"],
		setup() {
			onMounted(() => {
				DI.Forms.Optin.Dom.onReady(function () {
               DI.Forms.Optin.Client.InitOptinForm({
                  formIdent: 'DIForm_709_26036',
                  culture: 'en-US',
                  idBaseDiv: 'divForm_DIForm_709_26036',
                  recaptchaSiteKey: '',
                  fields: [
                     {"name":"f_EmployeeID","lbl":"Employee ID","id":"DIField_26036_f_EmployeeID","validators":["required"]},
                     {"name":"f_EMail","lbl":"EMail","id":"DIField_26036_f_EMail","validators":["required","email"]},
                     {"name":"f_FirstName","lbl":"First Name","id":"DIField_26036_f_FirstName","validators":[]},
                     {"name":"f_LastName","lbl":"Last Name","id":"DIField_26036_f_LastName","validators":[]},
                     {"name":"f_ReasonForOptout","lbl":"Reason For Opt-out","id":"DIField_26036_f_ReasonForOptout","validators":["required"],"inputType":"select"},
                     {"name":"f_OptOutMain","lbl":"Opt Out WinWin Staff Lottery","id":"DIField_26036_f_OptOutMain","validators":[],"inputType":"checkbox"},
                     {"name":"f_OptOut5050","lbl":"Opt Out Quarterly Cash 5050","id":"DIField_26036_f_OptOut5050","validators":[],"inputType":"checkbox"}
                  ],
                  fieldValues: {"f_OptOutMain":0,"f_OptOut5050":0},
                  errorMessages: {"general":"Error in form.","required":"The field {0} is required.","dataType":"The datatype for {0} is invalid.","min":"The minimum value for {0} is {1}.","max":"The maximum value for {0} is {1}.","interval":"The value for {0} must be between {1} and {2}.","inputMask":"The value for {0} does not match the input format.","updateDupeKey":"Update could not be performed as this identifier already exists.","checkInlineErrors":"Please correct the errors below."} ,
                  idSuccessDiv: 'divForm_DIForm_709_26036_success',
                  mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
                  url: '//app.dialoginsight.com/A/WF.ashx',
                  idWorkflow: 22045,
                  wfKey: 'noKscc',
                  nodeKey: 'Optin',
                  visible: true
                     
               });
            });
			});
		},
		data(props) {
			return {
				form: {
					userId: props.user.apiData.UserId,
					firstName: props.user.apiData.Profile.FirstName,
					lastName: props.user.apiData.Profile.LastName,
					employeeId: props.user.apiData.Profile.EmployeeId,
					email: props.user.apiData.Profile.EmailAddress,
					address: props.user.apiData.Profile.AddressLineOne,
					province: props.user.apiData.Profile.Province,
					postalCode: props.user.apiData.Profile.PostalCode,
					phoneNumber: props.user.apiData.Profile.PhoneNumber,
               currentMainTicket: props.user.apiData.Profile.CurrentMainTicketPackage,
               current5050Ticket: props.user.apiData.Profile.Current5050TicketPackage,
				},
            bundleOptOutChecked: false,
            optOutCheckedMain: false,
            optOutChecked50: false,
            showInvalidFormMessage: false,
			};
		},
      computed: {
         formABundle: function () {
            if ((this.form.currentMainTicket == 20) && (this.form.current5050Ticket == 10)) {
               console.log("Bundle A");
               return true;
            } else if ((this.form.currentMainTicket == 30) && (this.form.current5050Ticket == 17.5)) {
               console.log("Bundle B");
               return true;
            } else if ((this.form.currentMainTicket == 35) && (this.form.current5050Ticket == 30)) {
               console.log("Bundle C");
               return true;
            } else {
               return false;
            }
         },
         isFormValid(){
            return this.optOutCheckedMain || this.optOutChecked50
         }
      },
		methods: {
         bundleOptOutHandler: function () {
            this.bundleOptOutChecked = !(this.bundleOptOutChecked)
            if (this.bundleOptOutChecked) {
               this.optOutCheckedMain = true;
               this.optOutChecked50 = true;
               console.log("Both True");
            } else {
               this.optOutCheckedMain = false;
               this.optOutChecked50 = false;
               console.log("Both False");
            }
         },
         validateAndSubmit(e) {
            this.showInvalidFormMessage = false
            if (!this.isFormValid) {
               this.showInvalidFormMessage = true
               return
            }
            // @ts-expect-error DI loaded from external script
            DI.Forms.Optin.Client.GetOptinForm('DIForm_709_26036').Submit(e.target)
            return false
         }
      },
	};
</script>
<style lang="scss">
	@import "../assets/styles.scss";
		


			.poppins { font-family: Poppins, sans-serif !important; }
	

			:root {
			  --shadow-color: 235deg 77% 10%;
			  --shadow-elevation-low:
				0px 0.9px 1px hsl(var(--shadow-color) / 0.34),
				0px 1.4px 1.6px -1.2px hsl(var(--shadow-color) / 0.34),
				0px 3.4px 3.8px -2.5px hsl(var(--shadow-color) / 0.34);
			  --shadow-elevation-medium:
				0px 0.9px 1px hsl(var(--shadow-color) / 0.29),
				0px 2.3px 2.6px -0.6px hsl(var(--shadow-color) / 0.29),
				0px 4.4px 5px -1.2px hsl(var(--shadow-color) / 0.29),
				-0.1px 8.9px 10px -1.9px hsl(var(--shadow-color) / 0.29),
				-0.1px 17.1px 19.2px -2.5px hsl(var(--shadow-color) / 0.29);
			  --shadow-elevation-high:
				0px 0.9px 1px hsl(var(--shadow-color) / 0.27),
				0px 4.1px 4.6px -0.3px hsl(var(--shadow-color) / 0.27),
				-0.1px 7.3px 8.2px -0.6px hsl(var(--shadow-color) / 0.27),
				-0.1px 11.1px 12.5px -0.8px hsl(var(--shadow-color) / 0.27),
				-0.1px 16.1px 18.1px -1.1px hsl(var(--shadow-color) / 0.27),
				-0.2px 23.2px 26.1px -1.4px hsl(var(--shadow-color) / 0.27),
				-0.3px 33px 37.1px -1.7px hsl(var(--shadow-color) / 0.27),
				-0.4px 46.2px 52px -1.9px hsl(var(--shadow-color) / 0.27),
				-0.5px 63.5px 71.4px -2.2px hsl(var(--shadow-color) / 0.27),
				-0.7px 85.6px 96.3px -2.5px hsl(var(--shadow-color) / 0.27);
			}

			p {
				margin: 16px 0px;
			}
	
	
/* ======== form styles ======== */

.royal { color: #1a1f56!important; }
.gold-1 { color: #C1B59B!important; }


.DialogInsightFormDiv { 
	color: #555;
	line-height: normal; word-wrap: normal; white-space: normal; position: relative; 
	font-family: Gotham, "Helvetica Neue", Helvetica, Arial, sans-serif; font-size: 16px;
}
.DialogInsightFormDiv label { vertical-align: middle; margin: 2px 8px 0px 2px; display: inline-block; position: relative; top: 3px; }
.DialogInsightFormDiv.DialogInsightLoading > * { visibility: hidden; }
.DialogInsightFormDiv.DialogInsightLoading {
	background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif);
	background-repeat: no-repeat; background-position: center center;
}
div.DialogInsightFormContainer { text-align: justify; }
			div.DialogInsightInputContainer { display: inline-block; vertical-align: top; min-height: 40px; width: 100%; }
div.DialogInsightFormRow { padding-bottom: 10px; }
div.DialogInsightLabel_LeftOfField { 
	display: inline-block; text-align: left; width: 250px; vertical-align: top; 
	padding-top: 7px; overflow: hidden; text-overflow: ellipsis; 
}
div.DialogInsightLabel_AboveField { padding-bottom: 2px; }
.DialogInsightFieldDescription { font-style: italic; color: #666666; }
.DialogInsightFormCategoryTitle { font-weight: bold; position: relative; height: 18px; padding-bottom: 5px; }
.DialogInsightFormCategoryTitleWithMargin { margin-top: 15px; }
.DialogInsightFormCategoryTitle > span { position: absolute; left: 0px; top: 0px; white-space: nowrap; }
.DialogInsightFormCategoryDescription { position: relative; height: 18px; }
.DialogInsightFormCategoryDescription > span { position: absolute; left: 0px; top: 0px; white-space: nowrap; }

/* Input controls */

			input[type=text].DialogInsightFormInput, select.DialogInsightFormInput, textarea.DialogInsightFormInput { 
				width: 100%; height: 40px; box-sizing: border-box; padding: 0px 12px; line-height: 40px; color: #555555;
				background-color: #ffffff; background-image: none; border: 1px solid #cccccc; border-radius: 0px;
				-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
				box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
				-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
				-o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
				transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
				font-family: 'Poppins', sans-serif; font-weight: 500; color: #06060F; font-size: 18px; line-height: 1;
}
.DialogInsightFormDiv input[type=radio], .DialogInsightFormDiv input[type=checkbox] { 
	vertical-align: middle; margin: 3px 0px 0px 0px; position: relative; top: 3px; text-align: justify;
}
select.DialogInsightFormInput { padding-top: 4px; padding-bottom: 4px; }
select.DialogInsightFormInput::-ms-expand { border: 0px none; background-color: white; }
select.DialogInsightFormInput:focus::-ms-value { background: transparent; color: #444444; }
textarea.DialogInsightFormInput { height: 80px; resize: none; padding-top: 4px; padding-bottom: 4px; line-height: normal; }
input[type=text].DialogInsightFormInput::-ms-clear { width: 0px; height: 0px; }
input[type=text].DialogInsightFormInput:focus, select.DialogInsightFormInput:focus, textarea.DialogInsightFormInput:focus { 
	border-color: #66afe9; outline: 0;
	-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
	box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
}
input[type=text].DialogInsightFormInput.DialogInsightFormInputDate { width: 100px; }
img.DialogInsightFormInputDatePickerIcon { width: 18px; height: 18px; cursor: pointer; position: absolute; left: 105px; top: 6px; }
input[type=text].DialogInsightFormInput.DialogInsightFormInputDateTime { width: 140px; }
img.DialogInsightFormInputDateTimePickerIcon { width: 18px; height: 18px; cursor: pointer; position: absolute; left: 145px; top: 6px; }
.DialogInsightDatePlaceholder { width: 75px; }
.DialogInsightDateTimePlaceholder { width: 115px; }

/* Errors */
.DialogInsightErrorContents { color: #ff3333; padding-top: 2px; padding-bottom: 2px; }
.DialogInsightGlobalErrors > div { 
	text-align: left; border-radius: 5px; background-color: #eeeeee; border: #ff3333 1px solid; 
	padding: 10px; color:#ff3333; max-width:500px; margin-bottom: 10px;
}
input[type=text].DialogInsightFieldInError, textarea.DialogInsightFieldInError { border-color: #990000; color: #660000; }
input[type=text].DialogInsightFieldInError:focus, textarea.DialogInsightFieldInError:focus { color: #555555; }
select.DialogInsightFieldInError { border-color: #990000; color: #660000; }
.DialogInsightUnselectable { 
	-webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; 
	-ms-user-select: none; -o-user-selectE: none; user-select: none; 
}

/* Simulated placeholders (input cue) */
div.DialogInsightInputWithPlaceholderContainer { position: relative; height: 40px; }
div.DialogInsightTextareaWithPlaceholderContainer { height: 80px; }
div.DialogInsightInputWithPlaceholderContainer .DialogInsightInputPlaceholderText {
	position: absolute; top: 8px; left: 13px; z-index: 1; color: #9f9f9f; pointer-events: none;
	overflow: hidden; display: inline-block; white-space: nowrap; max-width: 275px;
}
div.DialogInsightInputWithPlaceholderContainer input.DialogInsightInputWithPlaceholder,
div.DialogInsightInputWithPlaceholderContainer textarea.DialogInsightInputWithPlaceholder {
	position:absolute; left: 0px; top: 0px; with: 100%; z-index: 10; background-color: transparent;
	background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/emptyimagetoworkaroundiebug.gif);
}
.DialogInsightInputWithPlaceholderContainer.PlaceholderInputHasText .DialogInsightInputPlaceholderText { display: none; }

			/* Submit button */
			.DialogInsightFormSubmit input[type=submit] { 
				vertical-align: middle; display: inline-block; margin-bottom: 0; font-weight: bold; text-align: center;
				vertical-align: middle; touch-action: manipulation; cursor: pointer; background-image: none; border: 1px solid transparent;
				white-space: nowrap; font-size: 18px; border-radius: 2px;
				-webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;
				color: #ffffff; background-color: #1A1F56; border-color: #1A1F56;
			}
			.DialogInsightFormSubmit input[type=submit]:disabled { background-color: #CCCCCC; border-color: #CCCCCC; }
			.DialogInsightFormSubmit input[type=submit]:hover { background-color: #E5D876!important; border-color: #E5D876!important; color: #1A1F56!important; }
			.DialogInsightFormSubmit .DialogInsightFormSubmitLoader { visibility: hidden; margin-left: 5px; vertical-align: middle; }
			.DialogInsightFormSubmit.DialogInsightFormSubmitInProgress .DialogInsightFormSubmitLoader { visibility: visible !important; }


/* ======== date picker popup styles ======== */
.DialogInsightDatePicker { 
	position: absolute; padding: 100px; z-index: 6000;
	background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/emptyimagetoworkaroundiebug.gif);
}
.DialogInsightDatePickerContent { background-color: white; border: 1px solid #bbbbbb; padding: 6px; font-family: Arial, sans-serif; font-size: 13px; }
.DialogInsightDatePickerHeader { text-align: center; font-weight: bold; margin-bottom: 5px; font-size: 15px; position: relative; vertical-align: middle; height: 30px; line-height: 30px; }
.DialogInsightDatePickerHeader .DialogInsightDatePickerPrev { position: absolute; padding: 5px; left: 0px; top: 2px; cursor: pointer; width: 15px; height: 15px; text-align: center; line-height: 15px; }
.DialogInsightDatePickerHeader .DialogInsightDatePickerNext { position: absolute; padding: 5px; right: 0px; top: 2px; cursor: pointer; width: 15px; height: 15px; text-align: center; line-height: 15px; }
table.DialogInsightDatePickerMonthTbl { table-layout: fixed; border-collapse: separate; border-spacing: 4px; }
table.DialogInsightDatePickerMonthTbl th  { width: 26px; padding: 4px; text-align: center; font-weight: bold; }
table.DialogInsightDatePickerMonthTbl td { width: 26px; padding: 4px 6px 4px 2px; text-align: right; cursor: pointer; }
table.DialogInsightDatePickerMonthTbl td:hover { background-color: #F2F2F2; }
table.DialogInsightDatePickerMonthTbl td.OutOfMonth { color: #999999; }
table.DialogInsightDatePickerMonthTbl td.SelectedDate { background-color: #009900; color: white; font-weight: bold; }
table.DialogInsightDatePickerMonthTbl td.Today { font-weight: bold; }
.DialogInsightDatePickerFooter { padding: 5px; text-align: right; }
.DialogInsightDatePickerCloseBtn { background-color: #bbbbbb; color: black; padding: 5px 10px; display: inline-block; cursor: pointer; }
.DialogInsightTimePickerContainer { float: left; }
.DialogInsightTimePickerTxtbox { height: 15px; padding: 5px; box-sizing: content-box; width: 70px; margin-right: 10px; border: 1px solid #999999; }
.DialogInsightTimePickerTxtbox.Error { border: 1px solid #990000; color: #550000; }
div.DialogInsightDatePickerMonth { height: 19px; display: inline-block; line-height: 19px; vertical-align: middle; position: relative; top: -1px; }
input.DialogInsightDatePickerYear { 
	padding: 0px; width: 45px; margin: 0px 0px 0px 7px; vertical-align: middle; font-size: 15px; height: 19px; font-weight: bold; 
	border: 1px transparent; font-family: Arial, sans-serif; position: relative; top: -1px; padding: 0px; text-align: center; line-height: normal;
}
/* ======== lightbox styles ======== */
div.DialogInsightLightBoxBackground {
	position: absolute; left: 0px; top: 0px; bottom: 0px; right: 0px; width: 100%; height: 100%; z-index: 5000;
	background-color: rgba(0, 0, 0, 0.5);
}
div.DialogInsightLightBoxBackground.DialogInsightLightBoxBackground_OldIE {
	background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/PopupBgBlockerOlderIE.png);
}
div.DialogInsightLightBox {
	margin-left: -300px;
	padding: 15px 0px 15px 15px;
	border-radius: 3px;
	box-shadow: 0px 0px 10px #555555;
	background-color: white;
	position: absolute; left: 50%; top: 50px; z-index: 5001;
}
div.DialogInsightLightBoxCloseButton {
	position: absolute; right: -18px; top: -18px;
	width:35px; height:35px;
	background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/LightboxClose.png);
	cursor: pointer;
}
	
.card {
    font-family: "Poppins", sans-serif;
    color: #1A1F56;
    font-weight: 400;
}
	
	
	
	
         /*
			.button {
				display: inline-block;
				position: relative;
				cursor: pointer;
				outline: none;
				white-space: nowrap;
				margin: 5px;
				padding: 0 22px;
				font-size: 14px;
				height: 40px;
				line-height: 36px;
				background-color: rgba(0,0,0,0)!important;
				color: #E5D876;
				font-weight: 500;
				text-transform: uppercase;
				letter-spacing: 1px;
				border: 1px #E5D876 solid;
				text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
			}
			
			.button:hover, a:hover {

				color: #1a1f56!important;
				box-shadow: var(--shadow-elevation-medium);
			}
         */

         .button {
            display: inline-block;
            position: relative;
            cursor: pointer;
            outline: none;
            white-space: nowrap;
            margin: 5px;
            padding: 0 22px;
            font-size: 14px;
            height: 40px;
            line-height: 40px;
            background-color: #E5D876;
            color: #E5D876;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            border: 3px #E5D876 solid;
            text-shadow: 0px 0px 0px rgba(0,0,0,0.2);
         }


         .button:hover {
            background-color: #1a1f56;
            color: #FFF;
            text-shadow: 0px 0px 0px rgba(0,0,0,0.2);
         }


         .button2 {
				background-color: #ffd36c!important;
				color: #E5D876;
				font-weight: 700;
				text-transform: uppercase;
				letter-spacing: 1px;
				border: 1px #1a1f56 solid;
				text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
			}

         
              
	@font-face {
         font-family: 'Circular';
         font-weight: 400;
         src: url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.eot);
         src: url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.eot?#iefix) format('embedded-opentype'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.woff2) format('woff2'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.woff) format('woff'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.ttf) format('truetype'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Regular.svg) format('svg');
      }

      @font-face {
         font-family: 'Circular';
         font-weight: 700;
         src: url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.eot);
         src: url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.eot?#iefix) format('embedded-opentype'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.woff2) format('woff2'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.woff) format('woff'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.ttf) format('truetype'),
            url(chrome-extension://mfidniedemcgceagapgdekdbmanojomk/font/Circular-Pro-Black-Bold.svg) format('svg');
      }










      /* ----------------------------------------------------------------
---------------- |v| CUSTOM HELPER CLASSES |v| --------------------
-----------------------------------------------------------------*/

      .colossal-text {
         font-size: 272px !important;
         line-height: 1 !important;
      }

      .giant-text {
         font-size: 172px !important;
         line-height: 1 !important;
      }

      .large-text {
         font-size: 124px !important;
         line-height: 1 !important;
      }

      .text-112 {
         font-size: 112px !important;
         line-height: 1 !important;
      }

      .text-96 {
         font-size: 96px !important;
         line-height: 1 !important;
      }

      .text-84 {
         font-size: 84px !important;
         line-height: 1 !important;
      }

      .text-72 {
         font-size: 72px !important;
         line-height: 1 !important;
      }

      .text-60 {
         font-size: 60px !important;
         line-height: 1 !important;
      }

      .text-64 {
         font-size: 64px !important;
         line-height: 1 !important;
      }

      .text-48 {
         font-size: 48px !important;
         line-height: 1 !important;
      }

      .text-36 {
         font-size: 36px !important;
         line-height: 1 !important;
      }

      .text-32 {
         font-size: 32px !important;
         line-height: 1 !important;
      }

      .text-30 {
         font-size: 30px !important;
         line-height: 1 !important;
      }

      .text-26 {
         font-size: 26px !important;
         line-height: 1 !important;
      }

      .text-24 {
         font-size: 24px !important;
         line-height: 1 !important;
      }

      .text-20 {
         font-size: 20px !important;
         line-height: 1 !important;
      }

      .text-18 {
         font-size: 18px !important;
         line-height: 1 !important;
      }

      .text-14 {
         font-size: 14px !important;
         line-height: 1 !important;
      }

      .text-16 {
         font-size: 16px !important;
         line-height: 1 !important;
      }

      .text-12 {
         font-size: 12px !important;
         line-height: 1 !important;
      }

      .text-10 {
         font-size: 10px !important;
         line-height: 1 !important;
      }

      .lh1-0-7 {
         line-height: 0.7 !important;
      }

      .lh1-0 {
         line-height: 1 !important;
      }

      .lh1-1 {
         line-height: 1.1 !important;
      }

      .lh1-2 {
         line-height: 1.2 !important;
      }

      .lh1-3 {
         line-height: 1.3 !important;
      }

      .lh1-4 {
         line-height: 1.4 !important;
      }

      .lh1-5 {
         line-height: 1.5 !important;
      }

      .lh1-8 {
         line-height: 1.8 !important;
      }

      .ls6 {
         letter-spacing: 6px !important;
      }

      .ls7 {
         letter-spacing: 7px !important;
      }

      .ls8 {
         letter-spacing: 8px !important;
      }

      .ls9 {
         letter-spacing: 9px !important;
      }

      .ls10 {
         letter-spacing: 10px !important;
      }

      .ls-1 {
         letter-spacing: -1px !important;
      }

      .ls-2 {
         letter-spacing: -2px !important;
      }

      .ls-3 {
         letter-spacing: -3px !important;
      }

      .ls-4 {
         letter-spacing: -4px !important;
      }

      .ls-5 {
         letter-spacing: -5px !important;
      }

      .t100 {
         font-weight: 100 !important;
      }

      .t200 {
         font-weight: 200 !important;
      }

      .t300 {
         font-weight: 300 !important;
      }

      .t400 {
         font-weight: 400 !important;
      }

      .t500 {
         font-weight: 500 !important;
      }

      .t600 {
         font-weight: 600 !important;
      }

      .t700 {
         font-weight: 700 !important;
      }

      .t800 {
         font-weight: 800 !important;
      }

      .t900 {
         font-weight: 900 !important;
      }

      .white {
         color: #fff !important
      }

      .silver {
         color: #CCC !important
      }

      .black {
         color: #333 !important
      }

      .white-bg {
         background-color: rgba(255, 255, 255, 0.85) !important
      }

      .silver-bg {
         background-color: #CCC !important
      }

      .black-bg {
         background-color: #333 !important
      }

      .underline {
         text-decoration: #FFFFFF underline;
         opacity: 1;
      }

      .overline {
         text-decoration: red overline;
         opacity: 1;
      }

      .strikethrough {
         text-decoration: red line-through;
         opacity: 1;
      }

      .multiple {
         text-decoration: red underline overline line-through;
         opacity: 1;
      }

      .wavy {
         text-decoration: red underline overline wavy;
         opacity: 1
      }

      .justify-text {
         text-align: justify;
         text-justify: inter-word;
      }

      .hangindent-parent {
         margin-left: 20px;
      }

      .hangindent-child {
         text-indent: 20px;
         margin-left: -20px;
      }

      .topmargin-xs {
         margin-top: 15px !important;
      }

      .topmargin-xl {
         margin-top: 110px !important;
      }

      .bottommargin-xs {
         margin-bottom: 15px !important;
      }

      .bottommargin-xl {
         margin-bottom: 110px !important;
      }

      .allmargin-xs {
         margin: 15px;
      }

      .bottompadding-xl {
         padding-bottom: 110px !important;
      }

      .allpadding-xs {
         padding: 15px;
      }

      .allpadding-sm {
         padding: 30px;
      }

      .allpadding {
         padding: 50px;
      }

      .allpadding-lg {
         padding: 80px;
      }

      .allpadding-xl {
         padding: 110px;
      }

      .shadow-solid-white-sm {
         text-shadow: 1px 2px 0px rgba(255, 255, 255, 0.85) !important;
      }

      .shadow-solid-white-md {
         text-shadow: 2px 4px 0px rgba(255, 255, 255, 0.85) !important;
      }

      .shadow-solid-white-lg {
         text-shadow: 4px 8px 0px rgba(255, 255, 255, 0.85) !important;
      }

      .shadow-solid-silver-sm {
         text-shadow: 1px 2px 0px rgba(0, 0, 0, 0.15) !important;
      }

      .shadow-solid-silver-md {
         text-shadow: 2px 4px 0px rgba(0, 0, 0, 0.15) !important;
      }

      .shadow-solid-silver-lg {
         text-shadow: 4px 8px 0px rgba(0, 0, 0, 0.15) !important;
      }

      .shadow-solid-black-sm {
         text-shadow: 1px 2px 0px rgba(0, 0, 0, 0.85) !important;
      }

      .shadow-solid-black-md {
         text-shadow: 2px 4px 0px rgba(0, 0, 0, 0.85) !important;
      }

      .shadow-solid-black-lg {
         text-shadow: 4px 8px 0px rgba(0, 0, 0, 0.85) !important;
      }

      .clearSelection:hover,
      .process-btn:hover {
         background-color: #1a1f56 !important;
         color: #eaeaea !important;
         box-shadow: var(--shadow-elevation-medium);
      }

      .optin-form {
         margin: 25px 0;
         min-width: 316px;
         width: 100%;
         max-width: 100%;
         text-align: center;
      }

      .optin-form .DialogInsightFormInput {
         width: auto !important;
         border: none;
         border-bottom: 2px solid #333;
         color: #333;
         padding: 5px 12px !important;
         margin: 0 15px !important;
      }


      .optin-form #content {
         position: relative;
         background: transparent;
         background-image: initial;
         background-position-x: initial;
         background-position-y: initial;
         background-size: initial;
         background-repeat-x: initial;
         background-repeat-y: initial;
         background-attachment: initial;
         background-origin: initial;
         background-clip: initial;
         background-color: transparent;
      }


      .eloquent {
         font-family: eloquent-jf-pro, serif !important;
         font-weight: 400 !important;
         font-style: normal !important;
      }

      .gold-ombre {
         background: -webkit-linear-gradient(105deg, rgba(153, 153, 102, 1) 0%, rgba(245, 228, 177, 1) 27%, rgba(153, 135, 95, 1) 51%, rgba(231, 214, 164, 1) 80%, rgba(169, 151, 109, 1) 100%);
         -webkit-background-clip: text;
         -webkit-text-fill-color: transparent;
      }

      .button__label {
         display: block;
         background-color: transparent;
         color: #FFFFFF !important;
         transition: color .5s ease, background-color .5s ease;
      }


      #divForm_DIForm_709_18535 .container.p-4.mx-auto.center {
         display: none;
      }



      .DialogInsightFormDiv .tkt-pkg {
         vertical-align: top;
         margin: 2px 4px 0px 2px;
         display: inline-block;
         position: relative;
         top: 3px;
         flex: 0 0 24%;
         max-width: 24% !important;
      }

      .DialogInsightFormDiv label {
         vertical-align: top;
         margin: 0px !important;
         display: inline-block;
         position: relative;
         top: 3px;
      }

      .tkt-list .tkt-pkg .tkt-main,
      .tkt-list .tkt-pkg .tkt-5050 {
         background: #1A1F56;
         background: -moz-linear-gradient(-60deg, #303566 0%, #1A1F56 15%, #111111 100%);
         background: -webkit-linear-gradient(-60deg, #303566 0%, #1A1F56 15%, #111111 100%);
         background: linear-gradient(150deg, #303566 0%, #1A1F56 15%, #111111 100%);
         padding: 12px 0;
         margin-top: 0px;
      }

      .tkt-list .tkt-pkg .tkt-main:hover,
      .tkt-list .tkt-pkg .tkt-5050:hover {
         background: #1A1F56;
         background: -moz-linear-gradient(60deg, #1A1F56 0%, #303566 15%, #282828 100%);
         background: -webkit-linear-gradient(60deg, #1A1F56 0%, #303566 15%, #282828 100%);
         background: linear-gradient(-150deg, #1A1F56 0%, #303566 15%, #282828 100%);
         padding: 12px 0;
         margin-top: 0px;
      }

      .tkt-cost {
         font: 500 2.5em/1 Poppins, sans-serif;
         letter-spacing: -4px;
         padding-right: 5px !important;
         margin-left: -10px !important;
         text-align: right !important;
      }

      .tkt-bundle-grp h1 {
         font-size: 36px;
      }

      .tkt-list .tkt-pkg .tkt-5050 {
         margin-bottom: 30px;
      }

      .submit-disclaimer {
         margin: 50px;
      }





      /*BOOTSTRAP SNIPPETS*/

      html {
         -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }

      body {
         font-size: 1rem;
      }

      ::selection {
         background: #1ABC9C;
         color: #FFF;
         text-shadow: none;
      }

      #content {
         position: relative;
         background-color: #FFF;
      }

      .mx-auto {
         float: none !important;
      }

      a {
         text-decoration: none !important;
      }

      .section {
         position: relative;
         width: 100%;
         margin: 60px 0;
         padding: 60px 0;
         background-color: #F9F9F9;
         overflow: hidden;
      }

      .section .block-expand-categories {
         margin-top: 20px;
      }

      .text-dark {
         color: #FFF !important
      }

      .col-mb-50>.col,
      .col-mb-50>[class*="col-"] {
         padding-bottom: 50px;
      }

      .row {
         margin-left: 0px !important;
         margin-right: 0px !important;
      }

      .col-1,
      .col-2,
      .col-3,
      .col-4,
      .col-5,
      .col-6,
      .col-7,
      .col-8,
      .col-9,
      .col-10,
      .col-11,
      .col-12,
      .col,
      .col-auto,
      .col-sm-1,
      .col-sm-2,
      .col-sm-3,
      .col-sm-4,
      .col-sm-5,
      .col-sm-6,
      .col-sm-7,
      .col-sm-8,
      .col-sm-9,
      .col-sm-10,
      .col-sm-11,
      .col-sm-12,
      .col-sm,
      .col-sm-auto,
      .col-md-1,
      .col-md-2,
      .col-md-3,
      .col-md-4,
      .col-md-5,
      .col-md-6,
      .col-md-7,
      .col-md-8,
      .col-md-9,
      .col-md-10,
      .col-md-11,
      .col-md-12,
      .col-md,
      .col-md-auto,
      .col-lg-1,
      .col-lg-2,
      .col-lg-3,
      .col-lg-4,
      .col-lg-5,
      .col-lg-6,
      .col-lg-7,
      .col-lg-8,
      .col-lg-9,
      .col-lg-10,
      .col-lg-11,
      .col-lg-12,
      .col-lg,
      .col-lg-auto,
      .col-xl-1,
      .col-xl-2,
      .col-xl-3,
      .col-xl-4,
      .col-xl-5,
      .col-xl-6,
      .col-xl-7,
      .col-xl-8,
      .col-xl-9,
      .col-xl-10,
      .col-xl-11,
      .col-xl-12,
      .col-xl,
      .col-xl-auto {
         position: relative;
         width: 100%;
      }

      *,
      *::before,
      *::after {
         box-sizing: border-box;
      }

      article,
      aside,
      figcaption,
      figure,
      footer,
      header,
      hgroup,
      main,
      nav,
      section {
         display: block;
      }

      ml-auto,
      .mx-auto {
         margin-left: auto !important;
      }

      .mb-0,
      .my-0 {
         margin-bottom: 0 !important;
      }

      .mt-3,
      .my-3 {
         margin-top: 1rem !important;
      }

      .mb-5,
      .my-5 {
         margin-bottom: 3rem !important;
      }

      .p-0 {
         padding: 0 !important;
      }

      .pb-0,
      .py-0 {
         padding-bottom: 0 !important;
      }

      .pl-3,
      .px-3 {
         padding-left: 1rem !important;
      }

      .pr-3,
      .px-3 {
         padding-right: 1rem !important;
      }

      .p-4 {
         padding: 1.5rem !important;
      }

      h4,
      .h4 {
         font-size: 1.5rem;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
         margin-top: 0;
         margin-bottom: 0.5rem;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      .h1,
      .h2,
      .h3,
      .h4,
      .h5,
      .h6 {
         margin-bottom: 0.5rem;
         font-weight: 500;
         line-height: 1.2;
      }

      .clearfix::after {
         display: block;
         clear: both;
         content: "";
      }

      .bg-transparent {
         background-color: transparent !important;
      }

      .bg-dark {
         background-color: #343a40 !important;
      }

      .bg-dark:hover {
         background-color: #343a40 !important;
      }


      .justify-content-center {
         -ms-flex-pack: center !important;
         justify-content: center !important;
      }


      .text-white {
         color: #fff !important;
      }

      .d-flex {
         display: -ms-flexbox !important;
         display: flex !important;
      }


      .flex-column {
         -ms-flex-direction: column !important;
         flex-direction: column !important;
      }

      .bg-dark {
         background-color: #343a40 !important;
      }


      .row {
         display: -ms-flexbox;
         display: flex;
         -ms-flex-wrap: wrap;
         flex-wrap: wrap;
         margin-right: -15px;
         margin-left: -15px;
      }


      .col-12 {
         -ms-flex: 0 0 100%;
         flex: 0 0 100%;
         max-width: 100%;
      }



      .col-xl-8 {
         -ms-flex: 0 0 66.666667%;
         flex: 0 0 66.666667%;
         max-width: 66.666667%;
      }

      .col-lg-6 {
         -ms-flex: 0 0 50%;
         flex: 0 0 50%;
         max-width: 50%;
      }




      .col-xl-4 {
         -ms-flex: 0 0 33.333333%;
         flex: 0 0 33.333333%;
         max-width: 33.333333%;
      }



      .col-md-3 {
         -ms-flex: 0 0 25%;
         flex: 0 0 25%;
         max-width: 25%;
      }







      @media (min-width: 1200px) {



         .col-xl-9 {
            -ms-flex: 0 0 75%;
            flex: 0 0 75%;
            max-width: 75%;
         }

         .col-xl-8 {
            -ms-flex: 0 0 66.666667%;
            flex: 0 0 66.666667%;
            max-width: 66.666667%;
         }

         .col-xl-4 {
            -ms-flex: 0 0 33.333333%;
            flex: 0 0 33.333333%;
            max-width: 33.333333%;
         }

         .col-xl-3 {
            -ms-flex: 0 0 25%;
            flex: 0 0 25%;
            max-width: 25%;
         }


      }






      @media (min-width: 992px) {

         .flex-lg-row {
            -ms-flex-direction: row !important;
            flex-direction: row !important;
         }



         .col-lg-9 {
            -ms-flex: 0 0 75%;
            flex: 0 0 75%;
            max-width: 75%;
         }


         .col-lg-8 {
            -ms-flex: 0 0 66.666667%;
            flex: 0 0 66.666667%;
            max-width: 66.666667%;
         }

         .col-lg-6 {
            -ms-flex: 0 0 50%;
            flex: 0 0 50%;
            max-width: 50%;
         }

         .col-lg-4 {
            -ms-flex: 0 0 33.333333%;
            flex: 0 0 33.333333%;
            max-width: 33.333333%;
         }

         .flex-lg-row {
            -ms-flex-direction: row !important;
            flex-direction: row !important;
         }

         .block-expand-categories .expand-category img {
            max-width: 60%;
            padding-top: 20px;
            width: 60%;
            text-align: center;
            margin: 0 auto;
            top: 10px !important;
            position: relative;
         }

         .block-expand-categories.on-click .expand-category.active img,
         .block-expand-categories:not(.on-click) .expand-category:hover img {
            width: 60%;
            text-align: center;
            margin: 0 auto;
            top: 10px !important;
            position: relative;
         }


         .block-expand-categories.on-click .expand-category.active,
         .block-expand-categories:not(.on-click) .expand-category:hover {
            background-blend-mode: multiply !important;
         }


      }






      @media (max-width: 768px) {


         .col-md-4 {
            -ms-flex: 0 0 33.333333%;
            flex: 0 0 33.333333%;
            max-width: 33.333333%;
         }


         .col-md-3 {
            -ms-flex: 0 0 25%;
            flex: 0 0 25%;
            max-width: 25%;
         }

         .col-md-6 {
            -ms-flex: 0 0 50%;
            flex: 0 0 50%;
            max-width: 50%;
         }

         .DialogInsightFormDiv .tkt-pkg {
            vertical-align: top;
            margin: 2px 4px 0px 2px;
            display: inline-block;
            position: relative;
            top: 3px;
            flex: 0 0 100% !important;
            max-width: 100% !important;
         }




      }







      @media (max-width: 576px) {

         .container {
            width: 100%;
            margin-right: auto;
            margin-left: auto;
            padding-right: 0.5rem;
            padding-left: 0.5rem;
         }

         .col-1,
         .col-2,
         .col-3,
         .col-4,
         .col-5,
         .col-6,
         .col-7,
         .col-8,
         .col-9,
         .col-10,
         .col-11,
         .col-12,
         .col,
         .col-auto,
         .col-sm-1,
         .col-sm-2,
         .col-sm-3,
         .col-sm-4,
         .col-sm-5,
         .col-sm-6,
         .col-sm-7,
         .col-sm-8,
         .col-sm-9,
         .col-sm-10,
         .col-sm-11,
         .col-sm-12,
         .col-sm,
         .col-sm-auto,
         .col-md-1,
         .col-md-2,
         .col-md-3,
         .col-md-4,
         .col-md-5,
         .col-md-6,
         .col-md-7,
         .col-md-8,
         .col-md-9,
         .col-md-10,
         .col-md-11,
         .col-md-12,
         .col-md,
         .col-md-auto,
         .col-lg-1,
         .col-lg-2,
         .col-lg-3,
         .col-lg-4,
         .col-lg-5,
         .col-lg-6,
         .col-lg-7,
         .col-lg-8,
         .col-lg-9,
         .col-lg-10,
         .col-lg-11,
         .col-lg-12,
         .col-lg,
         .col-lg-auto,
         .col-xl-1,
         .col-xl-2,
         .col-xl-3,
         .col-xl-4,
         .col-xl-5,
         .col-xl-6,
         .col-xl-7,
         .col-xl-8,
         .col-xl-9,
         .col-xl-10,
         .col-xl-11,
         .col-xl-12,
         .col-xl,
         .col-xl-auto {
            position: relative;
            width: 100% !important;
            padding-right: 15px;
            padding-left: 15px;
            flex: 0 0 100% !important;
            max-width: 100% !important;
         }

         #DialogInsightFormContainer {
            margin: 0 auto;
         }

         .DialogInsightFormDiv .tkt-pkg {
            vertical-align: top;
            margin: 2px 4px 0px 2px;
            display: inline-block;
            position: relative;
            top: 3px;
            flex: 0 0 100% !important;
            max-width: 100% !important;
         }

         .tkt-bundle-cost {
            font-size: 48px !important;
            padding-top: 120px !important;
            padding-right: 10px !important;
            text-align: right !important;
            right: -30%;
            left: auto;
            bottom: initial;
            top: -45px;
         }

         .tkt-main .tkt-cost,
         .tkt-5050 .tkt-cost {
            margin-top: -20px;
         }

         .tkt-main p.tkt-txt.pt-4,
         .tkt-5050 p.tkt-txt.pt-4 {
            padding-top: 0px !important;
            padding-bottom: 20px;
         }

         .section .block-expand-categories {
            margin-top: 100px;
         }

         .block-expand-categories img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            padding: 10px 0;
         }

         .submit-disclaimer {
            margin: 50px 0;
         }


      }

        
            .poppins {
                font-family: Poppins, sans-serif !important;
            }

            .warning {
                color: #e93745 !important;
            }

            .bg-dark-royal {
                background: linear-gradient(0deg, rgba(26, 31, 86, .85), #000) !important;
                background-image: linear-gradient(0deg, rgba(26, 31, 86, 0.85), rgb(0, 0, 0)) !important;
            }

            :root {
                --shadow-color: 235deg 77% 10%;
                --shadow-elevation-low:
                    0px 0.9px 1px hsl(var(--shadow-color) / 0.34),
                    0px 1.4px 1.6px -1.2px hsl(var(--shadow-color) / 0.34),
                    0px 3.4px 3.8px -2.5px hsl(var(--shadow-color) / 0.34);
                --shadow-elevation-medium:
                    0px 0.9px 1px hsl(var(--shadow-color) / 0.29),
                    0px 2.3px 2.6px -0.6px hsl(var(--shadow-color) / 0.29),
                    0px 4.4px 5px -1.2px hsl(var(--shadow-color) / 0.29),
                    -0.1px 8.9px 10px -1.9px hsl(var(--shadow-color) / 0.29),
                    -0.1px 17.1px 19.2px -2.5px hsl(var(--shadow-color) / 0.29);
                --shadow-elevation-high:
                    0px 0.9px 1px hsl(var(--shadow-color) / 0.27),
                    0px 4.1px 4.6px -0.3px hsl(var(--shadow-color) / 0.27),
                    -0.1px 7.3px 8.2px -0.6px hsl(var(--shadow-color) / 0.27),
                    -0.1px 11.1px 12.5px -0.8px hsl(var(--shadow-color) / 0.27),
                    -0.1px 16.1px 18.1px -1.1px hsl(var(--shadow-color) / 0.27),
                    -0.2px 23.2px 26.1px -1.4px hsl(var(--shadow-color) / 0.27),
                    -0.3px 33px 37.1px -1.7px hsl(var(--shadow-color) / 0.27),
                    -0.4px 46.2px 52px -1.9px hsl(var(--shadow-color) / 0.27),
                    -0.5px 63.5px 71.4px -2.2px hsl(var(--shadow-color) / 0.27),
                    -0.7px 85.6px 96.3px -2.5px hsl(var(--shadow-color) / 0.27);
            }

            .card-alt {
                --background: rgba(0, 0, 0, 1);
                --background-checkbox: #e93745;
                --background-image: #1a1f56, rgba(26, 31, 86, 0.2);
                --text-color: #e93745;
                --text-headline: #FFF;
                --card-shadow: #e93745;
                --card-height: auto;
                --card-width: auto;
                --card-radius: 6px;
                --header-height: 47px;
                --blend-mode: screen;
                --transition: 0.15s;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }

            .card-alt:nth-child(odd) .card-alt__body-cover-image {
                --x-y1: 100% 90%;
                --x-y2: 67% 83%;
                --x-y3: 33% 90%;
                --x-y4: 0% 85%;
            }

            .card-alt:nth-child(even) .card-alt__body-cover-image {
                --x-y1: 100% 85%;
                --x-y2: 73% 93%;
                --x-y3: 25% 85%;
                --x-y4: 0% 90%;

            }

            .card-alt__input {
                position: absolute;
                display: block;
                outline: none;
                border: none;
                background: none;
                padding: 0;
                margin: 0;
                -webkit-appearance: none;
            }

            .card-alt__input:checked~.card-alt__body {
                --shadow: 0 0 0 3px var(--card-shadow);
                --check-border: #fff;
                --check-scale: 1;
                --check-opacity: 1;
            }

            .card-alt__input:checked~.card-alt__body .card-alt__body-cover-checkbox--svg {
                --stroke-color: #fff;
                --stroke-dashoffset: 0;
            }

            .card-alt__input:checked~.card-alt__body .card-alt__body-cover:after {
                --opacity-bg: 0.5;
            }

            .card-alt__input:checked~.card-alt__body .card-alt__body-cover-image {
                background: #1a1f56;
                filter: blur(3px) var(--filter-bg, grayscale(1)) !important;
                -webkit-clip-path: polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%);
                clip-path: polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%);
            }

            .card-alt__input:disabled~.card-alt__body {
                cursor: not-allowed;
                opacity: 0.5;
            }

            .card-alt__input:disabled~.card-alt__body:active {
                --scale: 1;
            }

            .card-alt__body {
                display: grid;
                grid-auto-rows: calc(var(--card-height) - var(--header-height)) auto;
                background: var(--background);
                height: var(--card-height);
                width: var(--card-width);
                border-radius: var(--card-radius);
                overflow: hidden;
                position: relative;
                cursor: pointer;
                box-shadow: var(--shadow, 0 4px 4px 0 rgba(0, 0, 0, 0.02));
                transition: transform var(--transition), box-shadow var(--transition);
                transform: scale(var(--scale, 1)) translateZ(0);
            }

            .card-alt__body:active {
                --scale: 0.96;
                background: var(--background);
            }

            .card-alt__body-cover {
                --c-border: var(--card-radius) var(--card-radius) 0 0;
                --c-width: 100%;
                --c-height: 100px;
                position: relative;
                margin: 0 auto;
                overflow: hidden;
            }

            .card-alt__body-cover:after {
                content: "";
                position: absolute;
                left: 0;
                top: 0;
                width: var(--c-width);
                height: var(--c-height);
                border-radius: var(--c-border);
                background: linear-gradient(to bottom right, var(--background-image));
                mix-blend-mode: var(--blend-mode);
                opacity: var(--opacity-bg, 1);
                transition: opacity var(--transition) linear;
            }

            .card-alt__body-cover-image {
                width: var(--c-width);
                height: var(--c-height);
                -o-object-fit: contain;
                object-fit: contain;
                border-radius: var(--c-border);
                padding: 0 30px;
            }

            .card-alt__body-cover-checkbox {
                background: var(--check-bg, var(--background-checkbox));
                border: 2px solid var(--check-border, #fff);
                position: absolute;
                right: 10px;
                top: 10px;
                z-index: 1;
                width: 28px;
                height: 28px;
                border-radius: 50%;
                opacity: var(--check-opacity, 0);
                transition: transform var(--transition), opacity calc(var(--transition) * 1.2) linear;
                transform: scale(var(--check-scale, 0));
            }

            .card-alt__body-cover-checkbox--svg {
                width: 13px;
                height: 11px;
                display: inline-block;
                vertical-align: top;
                fill: none;
                margin: 7px 0 0 5px;
                stroke: var(--stroke-color, #fff);
                stroke-width: 2;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-dasharray: 16px;
                stroke-dashoffset: var(--stroke-dashoffset, 16px);
                transition: stroke-dashoffset 0.4s ease var(--transition);
            }

            .card-alt__body-header {
                height: var(--header-height);
                background: var(--background);
                padding: 6px 10px 8px 10px;
            }

            .card-alt__body-header-title {
                color: var(--text-headline);
                font-weight: 700;
                margin-bottom: 8px;
            }

            .card-alt__body-header-subtitle {
                color: var(--text-color);
                font-weight: 500;
                font-size: 12px;
                letter-spacing: 1px;
                line-height: 1;
                margin-top: 4px;
                text-align: center;
            }

            body .grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-gap: 1rem;
            }


            /* ======== form styles ======== */
            .DialogInsightFormDiv {
                line-height: normal;
                word-wrap: normal;
                white-space: normal;
                position: relative;
                font-family: Gotham, "Helvetica Neue", Helvetica, Arial, sans-serif;
                font-size: 16px;
            }

            .DialogInsightFormDiv label {
                vertical-align: middle;
                margin: 2px 8px 0px 2px;
                display: inline-block;
                position: relative;
                top: 3px;
            }

            .DialogInsightFormDiv.DialogInsightLoading>* {
                visibility: hidden;
            }

            .DialogInsightFormDiv.DialogInsightLoading {
                background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif);
                background-repeat: no-repeat;
                background-position: center center;
            }

            div.DialogInsightFormContainer {
                text-align: justify;
            }

            div.DialogInsightInputContainer {
                display: inline-block;
                vertical-align: top;
                min-height: 40px;
                width: 100%;
            }

            div.DialogInsightFormRow {
                padding-bottom: 10px;
            }

            div.DialogInsightLabel_LeftOfField {
                display: inline-block;
                text-align: left;
                width: 250px;
                vertical-align: top;
                padding-top: 7px;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            div.DialogInsightLabel_AboveField {
                padding-bottom: 2px;
            }

            .DialogInsightFieldDescription {
                font-style: italic;
                color: #666666;
            }

            .DialogInsightFormCategoryTitle {
                font-weight: bold;
                position: relative;
                height: 18px;
                padding-bottom: 5px;
            }

            .DialogInsightFormCategoryTitleWithMargin {
                margin-top: 15px;
            }

            .DialogInsightFormCategoryTitle>span {
                position: absolute;
                left: 0px;
                top: 0px;
                white-space: nowrap;
            }

            .DialogInsightFormCategoryDescription {
                position: relative;
                height: 18px;
            }

            .DialogInsightFormCategoryDescription>span {
                position: absolute;
                left: 0px;
                top: 0px;
                white-space: nowrap;
            }

            /* Input controls */

            input[type=text].DialogInsightFormInput,
            select.DialogInsightFormInput,
            textarea.DialogInsightFormInput {
                width: 100%;
                height: 40px;
                box-sizing: border-box;
                padding: 0px 12px;
                line-height: 40px;
                color: #555555;
                background-color: #ffffff;
                background-image: none;
                border: 1px solid #cccccc;
                border-radius: 0px;
                -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0);
                -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
                -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
                transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
                font-family: 'Poppins', sans-serif;
                font-weight: 500;
                color: #06060F;
                font-size: 14px;
                line-height: 1;
            }

            .DialogInsightFormDiv input[type=radio],
            .DialogInsightFormDiv input[type=checkbox] {
                vertical-align: middle;
                margin: 3px 0px 0px 0px;
                position: relative;
                top: 3px;
                text-align: justify;
            }

            select.DialogInsightFormInput {
                padding-top: 4px;
                padding-bottom: 4px;
            }

            select.DialogInsightFormInput::-ms-expand {
                border: 0px none;
                background-color: white;
            }

            select.DialogInsightFormInput:focus::-ms-value {
                background: transparent;
                color: #444444;
            }

            textarea.DialogInsightFormInput {
                height: 80px;
                resize: none;
                padding-top: 4px;
                padding-bottom: 4px;
                line-height: normal;
            }

            input[type=text].DialogInsightFormInput::-ms-clear {
                width: 0px;
                height: 0px;
            }

            input[type=text].DialogInsightFormInput:focus,
            select.DialogInsightFormInput:focus,
            textarea.DialogInsightFormInput:focus {
                border-color: #66afe9;
                outline: 0;
                -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
                box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
            }

            input[type=text].DialogInsightFormInput.DialogInsightFormInputDate {
                width: 100px;
            }

            img.DialogInsightFormInputDatePickerIcon {
                width: 18px;
                height: 18px;
                cursor: pointer;
                position: absolute;
                left: 105px;
                top: 6px;
            }

            input[type=text].DialogInsightFormInput.DialogInsightFormInputDateTime {
                width: 140px;
            }

            img.DialogInsightFormInputDateTimePickerIcon {
                width: 18px;
                height: 18px;
                cursor: pointer;
                position: absolute;
                left: 145px;
                top: 6px;
            }

            .DialogInsightDatePlaceholder {
                width: 75px;
            }

            .DialogInsightDateTimePlaceholder {
                width: 115px;
            }

            /* Errors */
            .DialogInsightErrorContents {
                color: #ff3333;
                padding-top: 2px;
                padding-bottom: 2px;
            }

            .DialogInsightGlobalErrors>div {
                text-align: left;
                border-radius: 5px;
                background-color: #eeeeee;
                border: #ff3333 1px solid;
                padding: 10px;
                color: #ff3333;
                max-width: 500px;
                margin-bottom: 10px;
            }

            input[type=text].DialogInsightFieldInError,
            textarea.DialogInsightFieldInError {
                border-color: #990000;
                color: #660000;
            }

            input[type=text].DialogInsightFieldInError:focus,
            textarea.DialogInsightFieldInError:focus {
                color: #555555;
            }

            select.DialogInsightFieldInError {
                border-color: #990000;
                color: #660000;
            }

            .DialogInsightUnselectable {
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                -o-user-selectE: none;
                user-select: none;
            }

            /* Simulated placeholders (input cue) */
            div.DialogInsightInputWithPlaceholderContainer {
                position: relative;
                height: 40px;
            }

            div.DialogInsightTextareaWithPlaceholderContainer {
                height: 80px;
            }

            div.DialogInsightInputWithPlaceholderContainer .DialogInsightInputPlaceholderText {
                position: absolute;
                top: 8px;
                left: 13px;
                z-index: 1;
                color: #9f9f9f;
                pointer-events: none;
                overflow: hidden;
                display: inline-block;
                white-space: nowrap;
                max-width: 275px;
            }

            div.DialogInsightInputWithPlaceholderContainer input.DialogInsightInputWithPlaceholder,
            div.DialogInsightInputWithPlaceholderContainer textarea.DialogInsightInputWithPlaceholder {
                position: absolute;
                left: 0px;
                top: 0px;
                with: 100%;
                z-index: 10;
                background-color: transparent;
                background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/emptyimagetoworkaroundiebug.gif);
            }

            .DialogInsightInputWithPlaceholderContainer.PlaceholderInputHasText .DialogInsightInputPlaceholderText {
                display: none;
            }

            /* Submit button */
            .DialogInsightFormSubmit input[type=submit] {
                vertical-align: middle;
                display: inline-block;
                margin-bottom: 0;
                font-weight: bold;
                text-align: center;
                vertical-align: middle;
                touch-action: manipulation;
                cursor: pointer;
                background-image: none;
                border: 1px solid transparent;
                white-space: nowrap;
                font-size: 18px;
                border-radius: 2px;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                color: #ffffff;
                background-color: #1A1F56;
                border-color: #1A1F56;
            }

            .DialogInsightFormSubmit input[type=submit]:disabled {
                background-color: #CCCCCC;
                border-color: #CCCCCC;
            }

            .DialogInsightFormSubmit input[type=submit]:hover {
                background-color: #E5D876 !important;
                border-color: #E5D876 !important;
                color: #1A1F56 !important;
            }

            .DialogInsightFormSubmit .DialogInsightFormSubmitLoader {
                visibility: hidden;
                margin-left: 5px;
                vertical-align: middle;
            }

            .DialogInsightFormSubmit.DialogInsightFormSubmitInProgress .DialogInsightFormSubmitLoader {
                visibility: visible !important;
            }


            /* ======== date picker popup styles ======== */
            .DialogInsightDatePicker {
                position: absolute;
                padding: 100px;
                z-index: 6000;
                background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/emptyimagetoworkaroundiebug.gif);
            }

            .DialogInsightDatePickerContent {
                background-color: white;
                border: 1px solid #bbbbbb;
                padding: 6px;
                font-family: Arial, sans-serif;
                font-size: 13px;
            }

            .DialogInsightDatePickerHeader {
                text-align: center;
                font-weight: bold;
                margin-bottom: 5px;
                font-size: 15px;
                position: relative;
                vertical-align: middle;
                height: 30px;
                line-height: 30px;
            }

            .DialogInsightDatePickerHeader .DialogInsightDatePickerPrev {
                position: absolute;
                padding: 5px;
                left: 0px;
                top: 2px;
                cursor: pointer;
                width: 15px;
                height: 15px;
                text-align: center;
                line-height: 15px;
            }

            .DialogInsightDatePickerHeader .DialogInsightDatePickerNext {
                position: absolute;
                padding: 5px;
                right: 0px;
                top: 2px;
                cursor: pointer;
                width: 15px;
                height: 15px;
                text-align: center;
                line-height: 15px;
            }

            table.DialogInsightDatePickerMonthTbl {
                table-layout: fixed;
                border-collapse: separate;
                border-spacing: 4px;
            }

            table.DialogInsightDatePickerMonthTbl th {
                width: 26px;
                padding: 4px;
                text-align: center;
                font-weight: bold;
            }

            table.DialogInsightDatePickerMonthTbl td {
                width: 26px;
                padding: 4px 6px 4px 2px;
                text-align: right;
                cursor: pointer;
            }

            table.DialogInsightDatePickerMonthTbl td:hover {
                background-color: #F2F2F2;
            }

            table.DialogInsightDatePickerMonthTbl td.OutOfMonth {
                color: #999999;
            }

            table.DialogInsightDatePickerMonthTbl td.SelectedDate {
                background-color: #009900;
                color: white;
                font-weight: bold;
            }

            table.DialogInsightDatePickerMonthTbl td.Today {
                font-weight: bold;
            }

            .DialogInsightDatePickerFooter {
                padding: 5px;
                text-align: right;
            }

            .DialogInsightDatePickerCloseBtn {
                background-color: #bbbbbb;
                color: black;
                padding: 5px 10px;
                display: inline-block;
                cursor: pointer;
            }

            .DialogInsightTimePickerContainer {
                float: left;
            }

            .DialogInsightTimePickerTxtbox {
                height: 15px;
                padding: 5px;
                box-sizing: content-box;
                width: 70px;
                margin-right: 10px;
                border: 1px solid #999999;
            }

            .DialogInsightTimePickerTxtbox.Error {
                border: 1px solid #990000;
                color: #550000;
            }

            div.DialogInsightDatePickerMonth {
                height: 19px;
                display: inline-block;
                line-height: 19px;
                vertical-align: middle;
                position: relative;
                top: -1px;
            }

            input.DialogInsightDatePickerYear {
                padding: 0px;
                width: 45px;
                margin: 0px 0px 0px 7px;
                vertical-align: middle;
                font-size: 15px;
                height: 19px;
                font-weight: bold;
                border: 1px transparent;
                font-family: Arial, sans-serif;
                position: relative;
                top: -1px;
                padding: 0px;
                text-align: center;
                line-height: normal;
            }

            /* ======== lightbox styles ======== */
            div.DialogInsightLightBoxBackground {
                position: absolute;
                left: 0px;
                top: 0px;
                bottom: 0px;
                right: 0px;
                width: 100%;
                height: 100%;
                z-index: 5000;
                background-color: rgba(0, 0, 0, 0.5);
            }

            div.DialogInsightLightBoxBackground.DialogInsightLightBoxBackground_OldIE {
                background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/PopupBgBlockerOlderIE.png);
            }

            div.DialogInsightLightBox {
                margin-left: -300px;
                padding: 15px 0px 15px 15px;
                border-radius: 3px;
                box-shadow: 0px 0px 10px #555555;
                background-color: white;
                position: absolute;
                left: 50%;
                top: 50px;
                z-index: 5001;
            }

            div.DialogInsightLightBoxCloseButton {
                position: absolute;
                right: -18px;
                top: -18px;
                width: 35px;
                height: 35px;
                background-image: url(https://cdn.dialoginsight.com/DI/Forms/resources/LightboxClose.png);
                cursor: pointer;
            }

            .card {
                font-family: "Poppins", sans-serif;
                color: #1A1F56;
                font-weight: 400;
            }

            .button {
                font-family: "Poppins", sans-serif;
                display: inline-block;
                position: relative;
                cursor: pointer;
                outline: none;
                white-space: nowrap;
                margin: 5px;
                padding: 0 22px;
                font-size: 14px;
                height: 40px;
                line-height: 36px;
                background-color: transparent !important;
                color: #e5d876 !important;
                font-weight: 500 !important;
                text-transform: uppercase;
                letter-spacing: 1px;
                border: 1px solid #e5d876 !important;
                border-radius: 0 !important;
                text-shadow: 0 0 0 rgb(0 0 0 / 20%);
            }

            .button2:hover {
            // a:hover {
            //     /*				background-color: #1a1f56!important;*/
                color: #1a1f56 !important;
                box-shadow: var(--shadow-elevation-medium);
            }


.opt-out-confirmation-title{
   color: #182054;

   .opt-out-section{
      color: #beb79b
   }
}

.opt-out-confirmation-box{
   background: linear-gradient(to right, #f3efdd, #cbc3ae);
   border: 14px solid #182054;
   color: #182054;
}
</style>
